import { ParsedUrlQuery } from 'querystring';

export function getTransportType(query: ParsedUrlQuery) {
    if (query['transport_type']) {
        return query['transport_type'];
    }

    return '';
}
